module.exports = __webpack_public_path__ + "static/img/CommunityConnector.d623db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui/reports/CommunityConnector.png
// module id = CP5G
// module chunks = 1